export const styles = {
  options: {
    zIndex: 10000,
    primaryColor: '#4f46e5', // indigo-600 to match theme
    backgroundColor: '#ffffff',
    textColor: '#334155', // slate-700
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    arrowColor: '#ffffff',
    fontFamily: "'Istok Web', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  tooltip: {
    borderRadius: '0.75rem', // rounded-xl
    padding: '1.25rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    fontSize: '1.125rem', // text-lg
    fontWeight: '700',
    color: '#1e293b', // slate-800
    marginBottom: '0.5rem',
  },
  tooltipContent: {
    fontSize: '0.875rem', // text-sm
    lineHeight: '1.5',
    color: '#475569', // slate-600
    padding: '0.5rem 0',
  },
  buttonNext: {
    backgroundColor: '#2DD4BF', // indigo-600 (primary color)
    color: '#ffffff',
    borderRadius: '0.5rem', // rounded-lg
    padding: '0.625rem 1.25rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    border: 'none',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s',
  },
  buttonBack: {
    backgroundColor: '#f1f5f9', // slate-100
    color: '#475569', // slate-600
    borderRadius: '0.5rem',
    padding: '0.625rem 1.25rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    border: 'none',
    marginRight: '0.5rem',
  },
  buttonSkip: {
    color: '#64748b', // slate-500
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  buttonClose: {
    color: '#2DD4BF', // primary DEFAULT
    fontSize: '1.5rem',
    fontWeight: '700',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  spotlightPadding: 10,
  spotlightRadius: 12,
  beaconSize: {
    width: '1.5rem',
    height: '1.5rem',
  },
  spotlight: {
    borderRadius: '0.5rem',
  },
  beacon: {
    right: '20px',
  },
  beaconInner: {
    backgroundColor: '#4f46e5', // indigo-600
  },
  beaconOuter: {
    backgroundColor: 'rgba(79, 70, 229, 0.2)',
    borderColor: '#4f46e5',
  },
};

export const locale = {
  back: 'Back',
  close: 'Close',
  last: 'Finish',
  next: 'Next',
  skip: 'Skip',
};

export const MobileSteps = [
  {
    target: '.mobile-tour-dashboard',
    content:
      'Welcome to your Dashboard — your central hub where you can track everything at a glance!',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-campaign-agent-cta',
    content:
      'Tap here to create a new post. You\'ll pick a format, choose your photo source — AI-generated or from your library — then add instructions.',
    placement: 'top',
    offset: 8,
    disableBeacon: true,
  },
  {
    target: '.tour-campaign-agent-page-intro',
    content:
      'This is the Create flow. Three steps: pick a format, choose where your photo comes from, then describe what you want.',
    placement: 'bottom',
    offset: 8,
    disableBeacon: true,
  },
  {
    target: '.tour-campaign-agent-counts',
    content:
      'First, pick the post format. Story is 9:16 vertical and disappears after 24 hours. Feed is 1:1 square and stays on your profile.',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.tour-dashboard-posts-step',
    content:
      'Your posts appear here. Tap any generated post to review, edit, schedule, or publish it.',
    placement: 'bottom',
    offset: 4,
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-preview',
    content:
      'This is the post preview area — see how your content will look on Instagram and Facebook before posting!',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-regenerate',
    content:
      'Not happy with your post? Use regenerate to create a new version with different instructions.',
    placement: 'bottom',
    offset: 4,
    disableBeacon: true,
  },

  {
    target: '.mobile-tour-calendar',
    content:
      'Plan your content schedule here — stay organized and never miss an important posting day!',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-calendar-event',
    content:
      'This is a scheduled post event — tap to view details, edit, or reschedule your post as needed!',
    placement: 'auto',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '.mobile-tour-calendar-change-view',
    content:
      'Use this button to change your calendar view — switch between month, week, and day views to manage your schedule effectively!',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-brand',
    content:
      'Brand is where you keep the information the AI uses to sound and look like your business.',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.tour-brand-about',
    content:
      'This is your brand profile: name, logo, description, audience, tone, and values.',
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '[data-tab-btn="offerings"]',
    content: 'Switch here to manage the products and services your posts can promote.',
    placement: 'auto',
    disableBeacon: true,
  },

  {
    target: '.tour-brand-offerings',
    content:
      'Keep this list up to date so the agent knows which products or services it can feature.',
    placement: 'auto',
    disableBeacon: true,
  },
];
export const DesktopSteps = [
  {
    target: '.desktop-tour-dashboard',
    content:
      'Welcome to your Dashboard — your central hub where you can track everything at a glance!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-campaign-agent-cta',
    content:
      'Click here to create a new post. You\'ll pick a format, choose your photo source — AI-generated or from your library — then add instructions.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-campaign-agent-page',
    content:
      'This is the Create flow. Three steps: pick a format, choose where your photo comes from, then describe what you want.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-campaign-agent-counts',
    content:
      'First, pick the post format. Story is 9:16 vertical and disappears after 24 hours. Feed is 1:1 square and stays on your profile.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-no-posts-card',
    content:
      'Your generated posts appear here. If this area is empty, use Create to make your next post.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-for-story',
    content: 'This card shows your Story content — post quick updates on Instagram or Facebook!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-preview',
    content:
      'This is the post preview area — see how your content will look on Instagram and Facebook before posting!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-reschedule',
    content: 'Need to make changes? Use the reschedule option to adjust your posting time easily!',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-schedule',
    content: 'To schedule your post, you have to have the social accounts connected first.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-regenerate',
    content:
      'Not happy with your post? Use the regenerate option to create a new version with different styles or captions!',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-calendar',
    content:
      'Plan your content schedule here — stay organized and never miss an important posting day!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-calendar-event',
    content:
      'This is a scheduled post event — tap to view details, edit, or reschedule your post as needed!',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '.desktop-tour-calendar-change-view',
    content:
      'Use this button to change your calendar view — switch between month, week, and day views to manage your schedule effectively!',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-brand',
    content:
      'Brand is where you keep the information the AI uses to sound and look like your business.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-brand-about',
    content:
      'This is your brand profile: name, logo, description, audience, tone, and values.',
    // The brand-about card fills the viewport, so no side placement fits — with
    // 'top' (and even 'auto') the tooltip + its Next/Back controls rendered
    // above the top edge and were unclickable. 'center' pins the tooltip to the
    // middle of the screen, keeping the controls in view.
    placement: 'center',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
  {
    target: '[data-tab-btn="offerings"]',
    content: 'Switch here to manage the products and services your posts can promote.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrollParentFix: true,
  },

  {
    target: '.tour-brand-offerings',
    content:
      'Keep this list up to date so the agent knows which products or services it can feature.',
    placement: 'top',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
];
